import {createStore, combineReducers, compose, applyMiddleware} from 'redux'
import {reducer as formReducer} from 'redux-form'
import thunk from 'redux-thunk';
// import {persistStore} from 'redux-persist'
import callForApplicationReducer from './reducers/callForApplicationReducer'
import residentialAreaReducer from './reducers/residentialAreaReducer'
import applicationReducer from './reducers/applicationReducer'

const reducer = combineReducers({
	form: formReducer,
	application: applicationReducer,
	callForApplication: callForApplicationReducer,
	residentialArea: residentialAreaReducer
})

// Rehydrate the store.
// const store = compose()(createStore)(reducer, applyMiddleware(thunk))
// persistStore(store, {whitelist: ['myDataForm']}, () => {
// 	//console.log('rehydration complete')
// })


// Compose the store
const store = createStore(
  reducer,
  compose(
    applyMiddleware(thunk)
  )
)

export default store
